import { render, staticRenderFns } from "./questions-carousel.vue?vue&type=template&id=16bc980c&scoped=true&"
import script from "./questions-carousel.vue?vue&type=script&lang=js&"
export * from "./questions-carousel.vue?vue&type=script&lang=js&"
import style0 from "./questions-carousel.vue?vue&type=style&index=0&id=16bc980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc980c",
  null
  
)

export default component.exports